// Shop Enums
export enum PurchaseLimitType {
  NONE = 'NONE',
  ONE_TIME_PER_USER = 'ONE_TIME_PER_USER',
  LIMITED_QUANTITY_PER_USER = 'LIMITED_QUANTITY_PER_USER',
  TIME_LIMITED = 'TIME_LIMITED',
  PERIOD_LIMIT = 'PERIOD_LIMIT'
}

export enum OfferType {
  NORMAL = 'NORMAL',
  HOT = 'HOT'
}

export enum ServiceType {
  CHARACTER_RENAME = 'CHARACTER_RENAME',
  ROULETTE_TOKENS = 'ROULETTE_TOKENS'
}

// Shop DTOs
export interface PurchaseLimitResponseDto {
  id: number;
  quantity?: number;
  periodDays?: number;
  availableUntil?: string;
}

export interface ShopSubcategoryDto {
  id: number;
  name: string;
  categoryId: number;
}

export interface ShopCategoryDto {
  id: number;
  name: string;
  subcategories: ShopSubcategoryDto[];
}

export interface SimpleCapsuleContentDto {
  id: number;
  name: string;
  icon: string;
  iconPanel: string;
  wikiItemLevel?: number;
  minCount: number;
  maxCount: number;
  chance: number;
}

export interface ShopItemDto {
  id: number;
  baseItemId: number;
  itemName: string;
  itemIcon: string;
  itemIconPanel: string;
  wikiItemLevel?: number;
  itemDescription: string;
  categoryId: number;
  categoryName: string;
  subcategoryId?: number;
  subcategoryName?: string;
  count: number;
  price: number;
  purchaseLimitType: PurchaseLimitType;
  purchaseLimitConfig?: PurchaseLimitResponseDto;
  offerType: OfferType;
  isActive: boolean;
  canPurchase: boolean;
  remainingPurchases?: number;
  capsuleContents?: SimpleCapsuleContentDto[];
}

export interface PaginatedShopItemDto {
  content: ShopItemDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface ShopServiceDto {
  id: number;
  serviceType: ServiceType;
  name: string;
  description: string;
  icon: string;
  price: number;
  purchaseLimitType: PurchaseLimitType;
  purchaseLimitConfig?: PurchaseLimitResponseDto;
  isActive: boolean;
  canPurchase: boolean;
  remainingPurchases?: number;
}

// Purchase DTOs
export interface CreateItemPurchaseRequestDto {
  quantity: number;
}

export interface ItemPurchaseResponseDto {
  id: number;
  itemId: number;
  itemName: string;
  quantity: number;
  totalPrice: number;
  purchasedAt: string;
}

export interface CreateCharacterRenameRequestDto {
  characterName: string;
  newName: string;
}

export interface CharacterRenameResponseDto {
  id: number;
  characterId: number;
  oldName: string;
  newName: string;
  price: number;
  purchasedAt: string;
}

export interface CreateRouletteTokenPurchaseRequestDto {
  quantity: number;
}

// Shop Admin Types
export interface PurchaseLimitDto {
  id?: number;
  quantity?: number;
  periodDays?: number;
  availableUntil?: string;
}

export interface CreatePurchaseLimitDto {
  quantity?: number;
  periodDays?: number;
  availableUntil?: string;
}

export interface CreateShopCategoryDto {
  name: string;
}

export interface CreateShopSubcategoryDto {
  name: string;
  categoryId: number;
}

export interface CreateShopItemDto {
  baseItemId: number;
  categoryId: number;
  subcategoryId?: number;
  count: number;
  price: number;
  purchaseLimitType: PurchaseLimitType;
  purchaseLimitConfig: CreatePurchaseLimitDto;
  offerType: OfferType;
  isActive: boolean;
}

export interface UpdateShopItemDto {
  categoryId: number;
  subcategoryId?: number;
  count: number;
  price: number;
  purchaseLimitType: PurchaseLimitType;
  purchaseLimitConfig: CreatePurchaseLimitDto;
  offerType: OfferType;
  isActive: boolean;
}
